import { createReducer, on, Action } from '@ngrx/store';
import * as GooglePostAction from '../actions/google-post.actions';

export interface GooglePostState {
  images: any[];
  publishedPosts: any[];
}

const initialState: GooglePostState = {
  images: [],
  publishedPosts: [],
};

export const googlePostReducer = createReducer(
  initialState,
  on(GooglePostAction.publishPostSuccess, state => ({
    ...state,
    images: [],
  })),
  on(GooglePostAction.editPostSuccess, state => ({
    ...state,
    images: [],
  })),
  on(GooglePostAction.updateImagesStore, (state, payload) => ({
    ...state,
    images: [...state.images, ...payload.images],
  })),
  on(GooglePostAction.updateImagesStoreForEditSucess, (state, payload) => ({
    ...state,
    images: [...payload.images],
  })),
  on(GooglePostAction.deleteImageStoreSuccess, (state, payload) => ({
    ...state,
    images: payload.images,
  })),
  on(GooglePostAction.getPublishedPostsSuccess, (state, payload) => {
    const { publishedPosts } = payload;
    return {
      ...state,
      publishedPosts,
    };
  })
);

export function reducer(state: GooglePostState | undefined, action: Action) {
  return googlePostReducer(state, action);
}
